import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ClearSegFull } from '../ui/ClearSegLogo';
import useIsMobile from '../../lib/useIsMobile';

const C = {
  bg: '#FFFFFF',
  navy: '#1B2B4B',
  accent: '#2563EB',
  muted: '#64748B',
  border: '#E2E8F0',
  ctaBg: '#1B2B4B',
  ctaText: '#FFFFFF',
};

export default function MarketingNav() {
  const loc = useLocation();
  const isMobile = useIsMobile();
  const [showMenu, setShowMenu] = useState(false);

  const linkStyle = (path) => ({
    color: loc.pathname === path ? C.navy : C.muted,
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 500,
    transition: 'color 0.2s',
  });

  const mobileLinkStyle = (path) => ({
    ...linkStyle(path),
    fontSize: 16,
    padding: '12px 0',
    display: 'block',
    borderBottom: `1px solid ${C.border}`,
  });

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: `${C.bg}ee`, backdropFilter: 'blur(12px)',
      borderBottom: `1px solid ${C.border}`,
    }}>
      <div style={{
        maxWidth: 1200, margin: '0 auto', padding: '14px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <ClearSegFull iconSize={32} textSize={18} />
        </Link>

        {isMobile ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Link to="/intake" style={{ textDecoration: 'none' }}>
              <button style={{
                background: C.ctaBg, color: C.ctaText, border: 'none',
                padding: '8px 16px', borderRadius: 6, fontSize: 13, fontWeight: 600,
                cursor: 'pointer',
              }}>
                Start Study
              </button>
            </Link>
            <button
              onClick={() => setShowMenu(!showMenu)}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                padding: 4, display: 'flex', flexDirection: 'column', gap: 4,
              }}
              aria-label="Toggle menu"
            >
              <span style={{ display: 'block', width: 22, height: 2, background: C.navy, borderRadius: 1, transition: 'transform 0.2s', transform: showMenu ? 'rotate(45deg) translateY(6px)' : 'none' }} />
              <span style={{ display: 'block', width: 22, height: 2, background: C.navy, borderRadius: 1, opacity: showMenu ? 0 : 1, transition: 'opacity 0.2s' }} />
              <span style={{ display: 'block', width: 22, height: 2, background: C.navy, borderRadius: 1, transition: 'transform 0.2s', transform: showMenu ? 'rotate(-45deg) translateY(-6px)' : 'none' }} />
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
            <Link to="/" style={linkStyle('/')}>Home</Link>
            <Link to="/faq" style={linkStyle('/faq')}>FAQ</Link>
            <Link to="/calculator" style={linkStyle('/calculator')}>Calculator</Link>
            <Link to="/blog" style={linkStyle('/blog')}>Blog</Link>
            <Link to="/partners" style={linkStyle('/partners')}>Partners</Link>
            <Link to="/login" style={linkStyle('/login')}>Login</Link>
            <Link to="/intake" style={{ textDecoration: 'none' }}>
              <button style={{
                background: C.ctaBg, color: C.ctaText, border: 'none',
                padding: '10px 22px', borderRadius: 6, fontSize: 14, fontWeight: 600,
                cursor: 'pointer',
                transition: 'opacity 0.15s',
              }}
              onMouseEnter={e => { e.target.style.opacity = '0.9'; }}
              onMouseLeave={e => { e.target.style.opacity = '1'; }}
              >
                Start Your Study
              </button>
            </Link>
          </div>
        )}
      </div>

      {isMobile && showMenu && (
        <div style={{
          background: C.bg,
          borderTop: `1px solid ${C.border}`,
          padding: '8px 24px 16px',
        }}>
          <Link to="/" style={mobileLinkStyle('/')} onClick={() => setShowMenu(false)}>Home</Link>
          <Link to="/faq" style={mobileLinkStyle('/faq')} onClick={() => setShowMenu(false)}>FAQ</Link>
          <Link to="/calculator" style={mobileLinkStyle('/calculator')} onClick={() => setShowMenu(false)}>Calculator</Link>
          <Link to="/blog" style={mobileLinkStyle('/blog')} onClick={() => setShowMenu(false)}>Blog</Link>
          <Link to="/partners" style={mobileLinkStyle('/partners')} onClick={() => setShowMenu(false)}>Partners</Link>
          <Link to="/login" style={{ ...mobileLinkStyle('/login'), borderBottom: 'none' }} onClick={() => setShowMenu(false)}>Login</Link>
        </div>
      )}
    </nav>
  );
}
